// extracted by mini-css-extract-plugin
module.exports = {"recipeRow":"outRecipe_recipeRow__Z7As4","recipeTabs":"outRecipe_recipeTabs__3oXzR","pdfMask":"outRecipe_pdfMask__FDZxS","tabs":"outRecipe_tabs__1vYUZ"};